/**
 * Environment detection + build-stamp constants.
 *
 * VITE_* env vars are baked at build time by CI (see deploy.yml). Locally
 * they fall back to defaults so `npm run dev` works without ceremony.
 */

declare const __APP_VERSION__: string;
declare const __APP_COMMIT__: string;
declare const __APP_ENV__: string;

export const APP_VERSION = __APP_VERSION__;
export const APP_COMMIT = __APP_COMMIT__;
export const APP_ENV = __APP_ENV__ as 'development' | 'staging' | 'production';

export const IS_PROD = APP_ENV === 'production';
export const IS_STAGING = APP_ENV === 'staging';
export const IS_DEV = APP_ENV === 'development';
